import type { MenuProps } from 'antd';
// import { type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
// import { useChatContext } from '@/contexts/chat/context';
// import { useSessionContext } from '@/contexts/session/context';
// import { MediaType } from '@/contexts/chat/scripts/hooks/useQuickVO/types';
import type { ReactNode } from 'react';
import { ChatMessagePayloadType } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { isDebug } from '@/scripts/utils/devUtils';
import { useChatContext } from '@/contexts/chat/context';
import styles from './index.module.scss';
import CallIcon from './images/call.svg?react';
import VoiceIcon from './images/voice.svg?react';
import VideoIcon from './images/video.svg?react';

const ChatHeaderMediaCall = ({
  isGroup = false,
  onClick,
  chatMediaCall,
  children,
  className,
}: {
  isGroup?: boolean;
  onClick: MenuProps['onClick'];
  chatMediaCall: any;
  children?: ReactNode | ((loading: boolean) => ReactNode);
  className?: ClassNames;
}) => {
  const { mediaLoading } = useChatContext();

  const items: MenuProps['items'] = useMemo(() => {
    const data = [
      {
        key: ChatMessagePayloadType.MEDIA_AUDIO_CALL,
        label: (
          <div className={styles.callItem}>
            <VoiceIcon></VoiceIcon>
            <div>Voice Call</div>
          </div>
        ),
      },
      {
        key: ChatMessagePayloadType.MEDIA_VIDEO_CALL,
        label: (
          <div className={styles.callItem}>
            <VideoIcon></VideoIcon>
            <div>Video Call</div>
          </div>
        ),
      },
    ];
    if (isDebug && isGroup) {
      data.push({
        key: 'select-members' as any,
        label: (
          <div className={styles.callItem}>
            <div>Select Members</div>
          </div>
        ),
      });
    }
    return data;
  }, [isGroup]);

  if (chatMediaCall?.chatMediaInfo) {
    return <></>;
  }

  return (
    <>
      <Dropdown
        className={cls(styles.calls, className)}
        overlayClassName={styles.callDrop}
        getPopupContainer={(e) => e.parentElement as HTMLDivElement}
        menu={{
          items,
          onClick: onClick,
        }}
        placement="bottomLeft"
        disabled={mediaLoading}
      >
        <div>
          {children ? (
            typeof children === 'function' ? (
              children(mediaLoading)
            ) : (
              children
            )
          ) : mediaLoading ? (
            <LoadingOutlined></LoadingOutlined>
          ) : (
            <CallIcon></CallIcon>
          )}
        </div>
      </Dropdown>
    </>
  );
};

export default ChatHeaderMediaCall;
